<template>
  <v-container>
    <v-card>
      <v-card-title>Profile</v-card-title>
      <v-card-item>
        <v-list>

        </v-list>
      </v-card-item>
    </v-card>
  </v-container>
</template>

<script setup>
import {useAppStore} from "@/stores/app";

const appStore = useAppStore();

</script>

<style scoped>

</style>
